import { Component, OnInit } from '@angular/core';
import { StaticContentService } from '../../../static-content/services/static-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
@Component({
    selector: 'contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss', '../../../static-content/Component/faq/faq.component.scss', '../../../static-content/Component/terms/terms.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  contactDetail: any = {};
  bondsAddress: any ={};
  bondsEnquiryDetails: any ={};
  socialMedia: any = [];
  CONTACT_QUERY = gql`
  query  {
    contactUses{
      heading
	  id
      mainContent
	  secondaryContent
    }
    bondsAddresses{
        address
		heading
		id
    }
    bondsEnquiryDetails{
        email
		heading
		id
		phoneNumber
		timing
    }
    socialMediasWOS{
      id
      stage
      url
      image1{
          id
          fileName
          url
      }
      image2{
          id
          fileName
          url
      }
  }
}
`;
  contactUsForm: FormGroup;
  submitted = false;
  user: any;
  private query: QueryRef<any>;
  constructor(private contactService: StaticContentService, private formBuilder: FormBuilder,
    private customValidator: CustomValidatorService, private toastService: AlertService,
    private apollo: Apollo, private statePersist: StatePersistService) { }

  ngOnInit(): void {
    this.user = this.statePersist.getLocalStorage('currentUser')
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.contactUsForm = this.formBuilder.group({
      name:['', [Validators.required, Validators.maxLength(30)]],
      email: ['', [Validators.required, Validators.email, this.customValidator.emailValidator]],
      message:['', [Validators.required, Validators.maxLength(500)]],
    });

    this.query = this.apollo.watchQuery({
      query: this.CONTACT_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.contactDetail = result.data.contactUses[0]
      this.bondsAddress = result.data.bondsAddresses[0]
      this.bondsEnquiryDetails = result.data.bondsEnquiryDetails[0]
      this.socialMedia = result.data
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  }

  contactUsSubmit(){
    this.submitted = true;

    if (this.contactUsForm.invalid) {
      return;
    }
    var fields = this.contactUsForm.controls
    var dataObj = new Object
    dataObj['name'] = fields.name.value
    dataObj['email'] = fields.email.value
    dataObj['message'] = fields.message.value
    this.contactService.contactUs(dataObj)
    .subscribe(
      data => {
          this.toastService.success('Your contact us request submitted successfully');
          this.contactUsForm.reset()
          this.contactUsForm.setErrors(null); 
          this.submitted = false;
        },
        error => {
        }
      );
  }

}
